import type { SxProps, Theme } from '@mui/material/styles';

/**
 * スクリーンリーダー専用テキスト用の sx。
 * MUI の sx では width: 1 は 100% を意味するため、必ず '1px' の文字列で指定する(ESLint でも禁止)。
 *
 * position: absolute にしない: 表のセル(position: static)の中の絶対配置は、セルではなく
 * 外側の位置指定された祖先を基準にするので、横に長い表の右端のセルにあると
 * 外側のスクロール領域(main)を横に広げてしまう。通常の流れの中の 1px の箱にして、はみ出しようをなくす。
 */
export const VISUALLY_HIDDEN_SX = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  verticalAlign: 'top',
  overflow: 'hidden',
  padding: 0,
  display: 'inline-block',
  position: 'relative',
  whiteSpace: 'nowrap',
  width: '1px',
} as const satisfies SxProps<Theme>;
